import React, { useRef, useEffect, useState } from 'react';

const Wheel = ({ cuisines, isSpinning, rotation, onSegmentChange }) => {
  const canvasRef = useRef(null);
  const [prevSegment, setPrevSegment] = useState(null);
  
  const segmentColors = ['#FF4785', '#FFD600', '#00D4FF', '#00FF94', '#D946EF', '#FF8F00'];
  
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) - 10;
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    const anglePerSegment = (2 * Math.PI) / cuisines.length;
    
    cuisines.forEach((cuisine, index) => {
      // Offset by half a segment so arrow points to CENTER of segment, not edge
      const startAngle = index * anglePerSegment - anglePerSegment / 2 + (rotation * Math.PI / 180);
      const endAngle = startAngle + anglePerSegment;
      
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.closePath();
      
      ctx.fillStyle = segmentColors[index % segmentColors.length];
      ctx.fill();
      
      ctx.strokeStyle = '#000';
      ctx.lineWidth = 3;
      ctx.stroke();
      
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(startAngle + anglePerSegment / 2);
      ctx.textAlign = 'right';
      ctx.fillStyle = '#000';
      ctx.font = 'bold 14px Fredoka, sans-serif';
      ctx.fillText(cuisine, radius - 20, 5);
      ctx.restore();
    });
    
    if (isSpinning) {
      const normalizedRotation = ((rotation % 360) + 360) % 360;
      // Arrow is at 90 degrees (3 o'clock)
      const adjustedRotation = (450 - normalizedRotation) % 360;
      const currentSegmentIndex = Math.floor(adjustedRotation / (360 / cuisines.length)) % cuisines.length;
      
      if (currentSegmentIndex !== prevSegment) {
        setPrevSegment(currentSegmentIndex);
        if (onSegmentChange) {
          onSegmentChange(currentSegmentIndex);
        }
      }
    }
  }, [cuisines, rotation, isSpinning, prevSegment, onSegmentChange]);
  
  return (
    <div className="relative flex items-center justify-center">
      {/* Arrow at 3 o'clock position (right side) */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-20">
        <div className="w-0 h-0 border-t-[20px] border-t-transparent border-b-[20px] border-b-transparent border-r-[30px] border-r-black"></div>
      </div>
      
      <div className="border-4 border-black rounded-full shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] bg-white p-2">
        <canvas
          ref={canvasRef}
          width={300}
          height={300}
          className="rounded-full"
        />
      </div>
      
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-12 h-12 bg-white border-4 border-black rounded-full shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"></div>
      </div>
    </div>
  );
};

export default Wheel;